/**
 * Libellé affichable du sexe d'un patient.
 *
 * La fiche patient affichait `gender === 'F' ? 'Féminin' : 'Masculin'` : un
 * dossier sans sexe — NULL en base, ou la chaîne vide que les formulaires y
 * laissaient entrer — s'affichait « Masculin ». C'est ce qui rendait le
 * problème invisible : personne ne pouvait savoir qu'il y avait à corriger.
 *
 *   'F'                          -> 'Féminin'
 *   'M', 'H' (héritage)          -> 'Masculin'
 *   '' '  ' null undefined 'X'   -> 'Non renseigné'
 */
export const formatGender = (gender: string | null | undefined): string => {
  const normalized = (gender ?? '').trim().toUpperCase()
  if (normalized === 'F') return 'Féminin'
  // 'H' pour « Homme » : héritage présent en base, équivalent à 'M'.
  if (normalized === 'M' || normalized === 'H') return 'Masculin'
  return 'Non renseigné'
}
